import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Outlet } from 'react-router-dom'

import { Header } from 'src/components'
import { useAuth } from 'src/hooks/useAuth'
import { useChangeBackground } from 'src/hooks/useChangeBackground'
import { useGlobalStore } from 'src/zustand/providers/global-store-provider'
import { useTermsOfUse } from 'src/zustand/stores/termsOfUse.store'

import { useInitAdsProviders } from '../MainPage/components/BottleOnMainPage/components/LotteryBottle/hooks/useInitAdsProviders'
import styles from './Layout.module.scss'
import { useTelegramStartParamRedirect } from './hooks/useTelegramStartParamRedirect'

// import { useRedirectToWelcomePage } from './hooks/useRedirectToWelcomePage'

const Layout = () => {
  const location = useLocation()
  const user = useGlobalStore((store) => store.user)
  const toggleTerms = useTermsOfUse((state) => state.toggleTerms)

  useAuth()
  useChangeBackground(styles.background)

  // useRedirectToWelcomePage()
  useTelegramStartParamRedirect()

  useEffect(() => {
    if (localStorage.getItem('termsOfUse') !== 'true') {
      toggleTerms(true)
    }
  }, [])

  useEffect(() => {
    const hourPeriodInMc = localStorage.getItem('hourPeriodInMc')
    const ONE_HOUR_IN_MS = 60 * 60 * 1000

    if (!hourPeriodInMc) {
      const timeInMc = new Date().getTime()
      localStorage.setItem('hourPeriodInMc', String(timeInMc))

      localStorage.setItem('numberAdsViewedOnHour', '10')
    } else {
      const currentTimeInMc = new Date().getTime()

      const differenceBetweenPeriods = currentTimeInMc - +hourPeriodInMc

      if (differenceBetweenPeriods >= ONE_HOUR_IN_MS && localStorage.getItem('numberAdsViewedOnDay') !== '0') {
        localStorage.setItem('hourPeriodInMc', String(currentTimeInMc))
        localStorage.setItem('numberAdsViewedOnHour', '10')
      }
    }
  }, [])

  useEffect(() => {
    const dayPeriodInMc = localStorage.getItem('dayPeriodInMc')
    const ONE_DAY_IN_MS = 60 * 60 * 1000 * 24

    if (!dayPeriodInMc) {
      const timeInMc = new Date().getTime()
      localStorage.setItem('dayPeriodInMc', String(timeInMc))

      localStorage.setItem('numberAdsViewedOnDay', '100')
    } else {
      const currentTimeInMc = new Date().getTime()
      const differenceBetweenPeriods = currentTimeInMc - +dayPeriodInMc

      if (differenceBetweenPeriods >= ONE_DAY_IN_MS) {
        localStorage.setItem('hourPeriodInMc', String(currentTimeInMc))
        localStorage.setItem('numberAdsViewedOnDay', '100')
      }
    }
  }, [])

  const shouldRenderHeader = location.pathname !== '/referrals'

  window.Telegram.WebApp.enableClosingConfirmation()

  useInitAdsProviders()

  return (
    <>
      {shouldRenderHeader && <Header variant='main' />}

      {/* <main className={styles.main}>{!!user && <Outlet />}</main> */}
      <main className={styles.main}>
        <Outlet />
      </main>
      {/* <Footer /> */}
    </>
  )
}

export default Layout
